<template>

    <ux-form ref="form" :data="formData" width="240px" :colon="true" :rules="rules" label-width="56px" data-automation="addGroup" @close="close" @confirm="confirm">
        <ux-tree :data="data" showCheckbox></ux-tree>
    </ux-form>
</template>

<script>
    export default {
      data() {
        return {
          data: [{
            label: '一级 1',
            children: [{
              label: '二级 1-1',
              children: [{
                label: '三级 1-1-1'
              }]
            }]
          }, {
            label: '一级 2',
            disabled: true,
            children: [{
              label: '二级 2-1',
              children: [{
                label: '三级 2-1-1'
              }]
            }, {
              label: '二级 2-2',
              children: [{
                label: '三级 2-2-1'
              }]
            }]
          }, {
            label: '一级 3',
            children: [{
              label: '二级 3-1',
              children: [{
                label: '三级 3-1-1'
              }]
            }, {
              label: '二级 3-2',
              children: [{
                label: '三级 3-2-1'
              }]
            }]
          }],
        };
      },
      methods: {
        /**
             * 取消回调
             */
        close() {
          this.$uxModal.hide();
        },

        /**
             * 确认回调
             */
        confirm() {
          this.$refs['form'].validate((valid) => {
            if (valid) {
              // this.$emit('confirm', this.formData);
            }
          });
        },
      }
    };
</script>